import { ReactNode, useState } from "react";
import { Table } from "react-bootstrap";
import { NormativaI } from "interfaces/Normativa";
import { NormativasRow } from "./NormativasRow";
import { NormativaDetailModal } from "../NormativasDetailModal/NormativasDetailModal";
// import { DetailModal } from '../components/DetailModal/DetailModal';

interface Props {
  elementos: NormativaI[];
  renderActions?: (
    elemento: NormativaI,
    onClickShowDetail: (elemento: NormativaI) => void,
  ) => ReactNode;
}

export const NormativasTable = ({ elementos = [], renderActions }: Props) => {
  const [selectedNotificacionId, setSelectedNotificacionId] = useState<
    null | number | string
  >(null);

  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedElement, setSelectedElement] = useState<NormativaI | null>(
    null,
  );
  const [showModal, setShowModal] = useState(false);
  const onShowDetailModal = (elemento: NormativaI) => {
    setSelectedElement(elemento);
    setShowModal(true);
  };

  const onCloseDetailModal = () => {
    setShowModal(false);
    setTimeout(() => {
      setSelectedElement(null);
    }, 400);
  };
  const handleShowDetailModal = (id: number | string) => {
    setSelectedNotificacionId(id);
    setShowDetailModal(true);
  };

  const handleCloseModal = () => {
    setShowDetailModal(false);
  };

  return (
    <>
      <Table striped bordered className="table-container">
        <thead>
          <tr className="table-heading">
            <th>ID</th>
            <th>Nombre</th>
            <th>Descripción</th>
            <th>Tipo</th>
            <th>Efecto</th>
            <th>Alcance</th>
            <th>Validez Nacional</th>
            {renderActions && <th className="text-center">Acciones</th>}
          </tr>
        </thead>
        <tbody>
          {elementos.length > 0 ? (
            elementos.map((ctEl) => (
              <NormativasRow
                key={ctEl.id}
                elemento={ctEl}
                renderActions={
                  renderActions
                    ? (e) => renderActions(e, onShowDetailModal)
                    : undefined
                }
              />
            ))
          ) : (
            <tr>
              <td
                colSpan={renderActions ? 6 : 5}
                className="text-center table-error-message"
              >
                <p>
                  <b>No hay normativas para visualizar.</b> Para poder
                  visualizar normativas debes <br /> seleccionar el botón
                  agregar «Nueva normativa».
                </p>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <NormativaDetailModal
        elemento={selectedElement}
        showModal={showModal}
        onClose={onCloseDetailModal}
      ></NormativaDetailModal>
    </>
  );
};
